jQuery(function($){
    let faqItem = $('.rank-math-list-item');

    faqItem.each(function() {
        let answer = $(this).find('.rank-math-answer');

        $(this).attr('data-height', answer.height());
        answer.css('height', 0);

        $(this).find('.rank-math-question').on('click', function(){
            let height = $(this).parent().attr('data-height');
            
            
            if ($(this).parent().hasClass('active')){
                answer.css('height', 0);
                $(this).parent().toggleClass('active');
            }
            else {
                answer.css('height', height);
                $(this).parent().toggleClass('active');
            }
            
        });
    });
});